import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import BookLandingPageLayout from '~layouts/BookLandingPageLayout'
import WhitepaperLandingPageLayout from '~layouts/WhitepaperLandingPageLayout'

const WhitepaperLandingPage = ({
  data: { article },
  pageContext: { nodeType },
}) => {
  if (article.frontmatter.showBookMode) {
    return <BookLandingPageLayout article={article} nodeType={nodeType} />
  }

  return <WhitepaperLandingPageLayout article={article} nodeType={nodeType} />
}

WhitepaperLandingPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}

export default WhitepaperLandingPage

export const pageQuery = graphql`
  query WhitepaperLandingPageSingle($slug: String!) {
    article: mdx(
      fields: { slug: { eq: $slug } }
      fileAbsolutePath: { regex: "/src/whitepaper-landing-pages/" }
    ) {
      fileAbsolutePath
      frontmatter {
        seoTitle
        description
        slug
        socialMediaImage
        hero {
          heading
          headingSub
          clientLogo
          showClientLogo
          content
          form {
            embed
            heading
            programId
            thankYouMessage
          }
        }
        leftColumnContent
        rightColumnContent
        hideColumnContent
        showFooterCTA
        showProductOverview
        hideTeamIntro
        showBookMode
        bookImage
      }
      fields {
        slug
      }
    }
  }
`
